import { render, staticRenderFns } from "./authors_catalog.vue?vue&type=template&id=1d2e60c7"
import script from "./authors_catalog.vue?vue&type=script&lang=js"
export * from "./authors_catalog.vue?vue&type=script&lang=js"
import style0 from "./authors_catalog.vue?vue&type=style&index=0&id=1d2e60c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports